import type { IPresentation } from '@carboncopyco/types';
import { Modal, TextSubHeader } from '@carboncopyco/ui';
import SpeakerNotesBody from './SpeakerNotesBody';

const SpeakerNotesModal = ({
  presentation,
  open,
  onLearnMore,
  onClose,
}: {
  presentation: IPresentation;
  open: boolean;
  onLearnMore?: () => void;
  onClose?: () => void;
}) => {
  return (
    <Modal
      title={
        <TextSubHeader
          color="text-ds-natural-600"
          label={`${presentation.forClient} Notes`}
        />
      }
      open={open}
      onClose={onClose}
      containerClass="w-[420px]"
    >
      <SpeakerNotesBody
        speakerNotes={presentation.notes}
        onLearnMore={onLearnMore}
      />
    </Modal>
  );
};

export default SpeakerNotesModal;
